export default "__VITE_ASSET__DNQ3jfM7__"